import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Albaranes emitidos
    deliveryNotesEmit: {
      tableData: [],
      totalDeliveryNotesEmit: 0
    },
    queryDeliveryNotesEmit: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersDeliveryNotesEmit: [],

    // Albaranes Recibidos
    deliveryNotesReceived: {
      tableData: [],
      totalDeliveryNotesReceived: 0
    },
    queryDeliveryNotesReceived: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'RECEIVED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersDeliveryNotesReceived: [],
    // Combo estados albaranes
    optionsFilterStatusDelivery: [],

    // Datos Select Filtros Albaranes Emitidas
    optionsFilterBuyerDeliveryNoteEmit: [],
    optionsFilterSellerDeliveryNoteEmit: [],
    optionsFilterDateCreationDeliveryNoteEmit: [],
    optionsFilterDateIssueDeliveryNoteEmit: [],
    optionsFilterDeliveryNumberDeliveryNoteEmit: [],
    optionsFilterDeliveryDateDeliveryNoteEmit: [],
    // Datos Select Filtros Albaranes recibidos
    optionsFilterBuyerDeliveryNoteReceived: [],
    optionsFilterSellerDeliveryNoteReceived: [],
    optionsFilterDateCreationDeliveryNoteReceived: [],
    optionsFilterDateIssueDeliveryNoteReceived: [],
    optionsFilterDeliveryDateDeliveryNoteReceived: [],
    optionsFilterDeliveryNumberDeliveryNoteReceived: []
  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Albaranes Emitidas
    isShowBuyerDeliveryNoteEmit: true,
    isShowSellerDeliveryNoteEmit: true,
    isShowNumDeliveryNoteEmit: true,
    isShowDateCreationDeliveryNoteEmit: true,
    isShowDateIssueDeliveryNoteEmit: true,
    isShowStatusDeliveryNoteEmit: true,
    isShowServiceDeliveryNoteEmit: true,
    isShowCentroVendedorDeliveryNoteEmit: false,
    isShowCentroCompradorDeliveryNoteEmit: false,
    isShowCentroEntregaDeliveryNoteEmit: false,
    isShowEnvioDeliveryNoteEmit: false,
    isShowDeliveryDateDeliveryNoteEmit: true,

    // Columnas Tabla Albaranes recibidos
    isShowBuyerDeliveryNoteReceived: true,
    isShowSellerDeliveryNoteReceived: true,
    isShowNumDeliveryNoteReceived: true,
    isShowDateCreationDeliveryNoteReceived: true,
    isShowDateIssueDeliveryNoteReceived: true,
    isShowStatusDeliveryNoteReceived: true,
    isShowServiceDeliveryNoteReceived: true,
    isShowCentroVendedorDeliveryNoteReceived: false,
    isShowCentroCompradorDeliveryNoteReceived: false,
    isShowCentroEntregaDeliveryNoteReceived: false,    
    isShowRecepcionDeliveryNoteReceived: false,
    isShowDeliveryDateDeliveryNoteReceived: true,

    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesDeliveryNoteEmit: true,
    isShowItemCodeSellerLinesDeliveryNoteEmit: true,
    isShowItemCodeBuyerLinesDeliveryNoteEmit: true,
    isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit: true,
    isShowDescriptionLinesDeliveryNoteEmit: true,
    isShowOrderLinesDeliveryNoteEmit: true,
    isShowStatusLinesDeliveryNoteEmit: true,
    isShowQuantityLinesDeliveryNoteEmit: true,
    isShowMeasureLinesDeliveryNoteEmit: true,
    isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit: true,
    isShowQuantityTradeUnitLinesDeliveryNoteEmit: true,    
    isShowSerialNumberLinesDeliveryNoteEmit: true,
    isShowBatchLinesDeliveryNoteEmit: true,
    isShowExpirationDateLinesDeliveryNoteEmit: true,    
    isShowGtin14LinesDeliveryNoteEmit: true,

    // Columnas Tabla lineas recibidas
    isShowItemCodeLinesDeliveryNoteReceived: true,
    isShowItemCodeSellerLinesDeliveryNoteReceived: true,
    isShowItemCodeBuyerLinesDeliveryNoteReceived: true,
    isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived: true,
    isShowDescriptionLinesDeliveryNoteReceived: true,
    isShowOrderLinesDeliveryNoteReceived: true,    
    isShowStatusLinesDeliveryNoteReceived: true,
    isShowQuantityLinesDeliveryNoteReceived: true,
    isShowMeasureLinesDeliveryNoteReceived: true,
    isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived: true,
    isShowQuantityTradeUnitLinesDeliveryNoteReceived: true,    
    isShowSerialNumberLinesDeliveryNoteReceived: true,
    isShowBatchLinesDeliveryNoteReceived: true,
    isShowExpirationDateLinesDeliveryNoteReceived: true,    
    isShowGtin14LinesDeliveryNoteReceived: true    
  }
  return local
}
function setByUserLocalDelivery () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes) {
    const local = {
      // Columnas Tabla Albaranes Emitidas
      isShowBuyerDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowBuyerDeliveryNoteEmit,
      isShowSellerDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowSellerDeliveryNoteEmit,
      isShowNumDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowNumDeliveryNoteEmit,
      isShowDateCreationDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDateCreationDeliveryNoteEmit,
      isShowDateIssueDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDateIssueDeliveryNoteEmit,
      isShowStatusDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowStatusDeliveryNoteEmit,
      isShowServiceDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowServiceDeliveryNoteEmit,
      isShowCentroVendedorDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCentroVendedorDeliveryNoteEmit,
      isShowCentroCompradorDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCentroCompradorDeliveryNoteEmit,
      isShowCentroEntregaDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCentroEntregaDeliveryNoteEmit,
      isShowEnvioDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowEnvioDeliveryNoteEmitEmit,
      isShowDeliveryDateDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDeliveryDateDeliveryNoteEmit,

      // Columnas Tabla Albaranes recibidos
      isShowBuyerDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowBuyerDeliveryNoteReceived,
      isShowSellerDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowSellerDeliveryNoteReceived,
      isShowNumDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowNumDeliveryNoteReceived,
      isShowDateCreationDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDateCreationDeliveryNoteReceived,
      isShowDateIssueDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDateIssueDeliveryNoteReceived,
      isShowStatusDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowStatusDeliveryNoteReceived,
      isShowServiceDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowServiceDeliveryNoteReceived,
      isShowCentroVendedorDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCentroVendedorDeliveryNoteReceived,
      isShowCentroCompradorDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCentroCompradorDeliveryNoteReceived,
      isShowCentroEntregaDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCentroEntregaDeliveryNoteReceived,
      isShowRecepcionDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowRecepcionDeliveryNoteReceived,
      isShowDeliveryDateDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDeliveryDateDeliveryNoteReceived,

      // Columnas tabla lineas emitidas
      isShowItemCodeLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowItemCodeLinesDeliveryNoteEmit,
      isShowItemCodeSellerLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowItemCodeSellerLinesDeliveryNoteEmit,
      isShowItemCodeBuyerLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowItemCodeBuyerLinesDeliveryNoteEmit,
      isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit,
      isShowDescriptionLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDescriptionLinesDeliveryNoteEmit,
      isShowOrderLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowOrderLinesDeliveryNoteEmit,
      isShowStatusLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowStatusLinesDeliveryNoteEmit,
      isShowQuantityLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowQuantityLinesDeliveryNoteEmit,
      isShowMeasureLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowMeasureLinesDeliveryNoteEmit,
      isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit,
      isShowQuantityTradeUnitLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowQuantityTradeUnitLinesDeliveryNoteEmit,  
      isShowSerialNumberLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowSerialNumberLinesDeliveryNoteEmit,
      isShowBatchLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowBatchLinesDeliveryNoteEmit,
      isShowExpirationDateLinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowExpirationDateLinesDeliveryNoteEmit,
      isShowGtin14LinesDeliveryNoteEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowGtin14LinesDeliveryNoteEmit,

      // Columnas tabla lineas recibidas
      isShowItemCodeLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowItemCodeLinesDeliveryNoteReceived,
      isShowItemCodeSellerLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowItemCodeSellerLinesDeliveryNoteReceived,
      isShowItemCodeBuyerLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowItemCodeBuyerLinesDeliveryNoteReceived,
      isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived,
      isShowDescriptionLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowDescriptionLinesDeliveryNoteReceived,
      isShowOrderLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowOrderLinesDeliveryNoteReceived,
      isShowStatusLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowStatusLinesDeliveryNoteReceived,
      isShowQuantityLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowQuantityLinesDeliveryNoteReceived,
      isShowMeasureLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowMeasureLinesDeliveryNoteReceived,
      isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived,
      isShowQuantityTradeUnitLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowQuantityTradeUnitLinesDeliveryNoteReceived,  
      isShowSerialNumberLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowSerialNumberLinesDeliveryNoteReceived,
      isShowBatchLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowBatchLinesDeliveryNoteReceived,
      isShowExpirationDateLinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowExpirationDateLinesDeliveryNoteReceived,
      isShowGtin14LinesDeliveryNoteReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).albaranes.isShowGtin14LinesDeliveryNoteReceived                
    }
    return local
  } else {
    return initLocal()
  }
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla Albaranes Emitidas
    isShowBuyerDeliveryNoteEmit: true,
    isShowSellerDeliveryNoteEmit: true,
    isShowNumDeliveryNoteEmit: true,
    isShowDateCreationDeliveryNoteEmit: true,
    isShowDateIssueDeliveryNoteEmit: true,
    isShowStatusDeliveryNoteEmit: true,
    isShowServiceDeliveryNoteEmit: true,
    isShowCentroVendedorDeliveryNoteEmit: false,
    isShowCentroCompradorDeliveryNoteEmit: false,
    isShowCentroEntregaDeliveryNoteEmit: false,
    isShowEnvioDeliveryNoteEmit: false,
    isShowDeliveryDateDeliveryNoteEmit: true,    

    // Columnas Tabla Albaranes recibidos
    isShowBuyerDeliveryNoteReceived: true,
    isShowSellerDeliveryNoteReceived: true,
    isShowNumDeliveryNoteReceived: true,
    isShowDateCreationDeliveryNoteReceived: true,
    isShowDateIssueDeliveryNoteReceived: true,
    isShowStatusDeliveryNoteReceived: true,
    isShowServiceDeliveryNoteReceived: true,
    isShowCentroVendedorDeliveryNoteReceived: false,
    isShowCentroCompradorDeliveryNoteReceived: false,
    isShowCentroEntregaDeliveryNoteReceived: false,    
    isShowRecepcionDeliveryNoteReceived: false,
    isShowDeliveryDateDeliveryNoteReceived: true, 

    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesDeliveryNoteEmit: true,
    isShowItemCodeSellerLinesDeliveryNoteEmit: true,
    isShowItemCodeBuyerLinesDeliveryNoteEmit: true,
    isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit: true,
    isShowDescriptionLinesDeliveryNoteEmit: true,
    isShowOrderLinesDeliveryNoteEmit: true,    
    isShowStatusLinesDeliveryNoteEmit: true,
    isShowQuantityLinesDeliveryNoteEmit: true,
    isShowMeasureLinesDeliveryNoteEmit: true,
    isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit: true,
    isShowQuantityTradeUnitLinesDeliveryNoteEmit: true,    
    isShowSerialNumberLinesDeliveryNoteEmit: true,
    isShowBatchLinesDeliveryNoteEmit: true,
    isShowExpirationDateLinesDeliveryNoteEmit: true,
    isShowGtin14LinesDeliveryNoteEmit: false,

    // Columnas Tabla lineas recibidas
    isShowItemCodeLinesDeliveryNoteReceived: true,
    isShowItemCodeSellerLinesDeliveryNoteReceived: true,
    isShowItemCodeBuyerLinesDeliveryNoteReceived: true,
    isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived: true,
    isShowDescriptionLinesDeliveryNoteReceived: true,
    isShowOrderLinesDeliveryNoteReceived: true,    
    isShowStatusLinesDeliveryNoteReceived: true,
    isShowQuantityLinesDeliveryNoteReceived: true,
    isShowMeasureLinesDeliveryNoteReceived: true,
    isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived: true,
    isShowQuantityTradeUnitLinesDeliveryNoteReceived: true,    
    isShowSerialNumberLinesDeliveryNoteReceived: true,
    isShowBatchLinesDeliveryNoteReceived: true,
    isShowExpirationDateLinesDeliveryNoteReceived: true,
    isShowGtin14LinesDeliveryNoteReceived: false        
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Albaranes Emitidas
  deliveryNotesEmit: state => {
    return state.session.deliveryNotesEmit
  },
  queryDeliveryNotesEmit: state => {
    return state.session.queryDeliveryNotesEmit
  },
  listSelectedFiltersDeliveryNotesEmit: state => {
    return state.session.listSelectedFiltersDeliveryNotesEmit
  },

  // Datos Tabla Albaranes Recibidos
  deliveryNotesReceived: state => {
    return state.session.deliveryNotesReceived
  },
  queryDeliveryNotesReceived: state => {
    return state.session.queryDeliveryNotesReceived
  },
  listSelectedFiltersDeliveryNotesReceived: state => {
    return state.session.listSelectedFiltersDeliveryNotesReceived
  },

  // Datos Select Filtros Albaranes Emitidas
  optionsFilterBuyerDeliveryNoteEmit: state => {
    return state.session.optionsFilterBuyerDeliveryNoteEmit
  },
  optionsFilterSellerDeliveryNoteEmit: state => {
    return state.session.optionsFilterSellerDeliveryNoteEmit
  },
  optionsFilterDateCreationDeliveryNoteEmit: state => {
    return state.session.optionsFilterDateCreationDeliveryNoteEmit
  },
  optionsFilterDateIssueDeliveryNoteEmit: state => {
    return state.session.optionsFilterDateIssueDeliveryNoteEmit
  },
  optionsFilterDeliveryDateDeliveryNoteEmit: state => {
    return state.session.optionsFilterDeliveryDateDeliveryNoteEmit
  },  
  optionsFilterDeliveryNumberDeliveryNoteEmit: state => {
    return state.session.optionsFilterDeliveryNumberDeliveryNoteEmit
  },
  // Datos Select Filtros Albaranes Recibidos
  optionsFilterBuyerDeliveryNoteReceived: state => {
    return state.session.optionsFilterBuyerDeliveryNoteReceived
  },
  optionsFilterSellerDeliveryNoteReceived: state => {
    return state.session.optionsFilterSellerDeliveryNoteReceived
  },
  optionsFilterDateCreationDeliveryNoteReceived: state => {
    return state.session.optionsFilterDateCreationDeliveryNoteReceived
  },
  optionsFilterDateIssueDeliveryNoteReceived: state => {
    return state.session.optionsFilterDateIssueDeliveryNoteReceived
  },
  optionsFilterDeliveryDateDeliveryNoteReceived: state => {
    return state.session.optionsFilterDeliveryDateFromDeliveryNoteReceived
  }, 
  optionsFilterDeliveryNumberDeliveryNoteReceived: state => {
    return state.session.optionsFilterDeliveryNumberDeliveryNoteReceived
  },
  // Combo estados
  optionsFilterStatusDelivery: state => {
    return state.session.optionsFilterStatusDelivery
  },
  // Columnas Tabla Albaranes Emitidas
  isShowBuyerDeliveryNoteEmit: state => {
    return state.local.isShowBuyerDeliveryNoteEmit
  },
  isShowEnvioDeliveryNoteEmit: state => {
    return state.local.isShowEnvioDeliveryNoteEmit
  },
  isShowSellerDeliveryNoteEmit: state => {
    return state.local.isShowSellerDeliveryNoteEmit
  },
  isShowNumDeliveryNoteEmit: state => {
    return state.local.isShowNumDeliveryNoteEmit
  },
  isShowDateCreationDeliveryNoteEmit: state => {
    return state.local.isShowDateCreationDeliveryNoteEmit
  },
  isShowDateIssueDeliveryNoteEmit: state => {
    return state.local.isShowDateIssueDeliveryNoteEmit
  },
  isShowDeliveryDateDeliveryNoteEmit: state => {
    return state.local.isShowDeliveryDateDeliveryNoteEmit
  }, 
  isShowStatusDeliveryNoteEmit: state => {
    return state.local.isShowStatusDeliveryNoteEmit
  },
  isShowServiceDeliveryNoteEmit: state => {
    return state.local.isShowServiceDeliveryNoteEmit
  },
  isShowCentroVendedorDeliveryNoteEmit: state => {
    return state.local.isShowCentroVendedorDeliveryNoteEmit
  },
  isShowCentroCompradorDeliveryNoteEmit: state => {
    return state.local.isShowCentroCompradorDeliveryNoteEmit
  },
  isShowCentroEntregaDeliveryNoteEmit: state => {
    return state.local.isShowCentroEntregaDeliveryNoteEmit
  },

  // Columnas Tabla Albaranes Recibidos
  isShowBuyerDeliveryNoteReceived: state => {
    return state.local.isShowBuyerDeliveryNoteReceived
  },
  isShowRecepcionDeliveryNoteReceived: state => {
    return state.local.isShowRecepcionDeliveryNoteReceived
  },
  isShowSellerDeliveryNoteReceived: state => {
    return state.local.isShowSellerDeliveryNoteReceived
  },
  isShowNumDeliveryNoteReceived: state => {
    return state.local.isShowNumDeliveryNoteReceived
  },
  isShowDateCreationDeliveryNoteReceived: state => {
    return state.local.isShowDateCreationDeliveryNoteReceived
  },
  isShowDateIssueDeliveryNoteReceived: state => {
    return state.local.isShowDateIssueDeliveryNoteReceived
  },
  isShowDeliveryDateDeliveryNoteReceived: state => {
    return state.local.isShowDeliveryDateDeliveryNoteReceived
  },  
  isShowStatusDeliveryNoteReceived: state => {
    return state.local.isShowStatusDeliveryNoteReceived
  },
  isShowServiceDeliveryNoteReceived: state => {
    return state.local.isShowServiceDeliveryNoteReceived
  },
  isShowCentroVendedorDeliveryNoteReceived: state => {
    return state.local.isShowCentroVendedorDeliveryNoteReceived
  },
  isShowCentroCompradorDeliveryNoteReceived: state => {
    return state.local.isShowCentroCompradorDeliveryNoteReceived
  },
  isShowCentroEntregaDeliveryNoteReceived: state => {
    return state.local.isShowCentroEntregaDeliveryNoteReceived
  },
  // Columnas lineas pedido emitidas
  isShowItemCodeLinesDeliveryNoteEmit: state => {
    return state.local.isShowItemCodeLinesDeliveryNoteEmit
  },
  isShowItemCodeSellerLinesDeliveryNoteEmit: state => {
    return state.local.isShowItemCodeSellerLinesDeliveryNoteEmit
  },
  isShowItemCodeBuyerLinesDeliveryNoteEmit: state => {
    return state.local.isShowItemCodeBuyerLinesDeliveryNoteEmit
  },
  isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit: state => {
    return state.local.isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit
  },
  isShowDescriptionLinesDeliveryNoteEmit: state => {
    return state.local.isShowDescriptionLinesDeliveryNoteEmit
  },
  isShowOrderLinesDeliveryNoteEmit: state => {
    return state.local.isShowOrderLinesDeliveryNoteEmit
  },  
  isShowStatusLinesDeliveryNoteEmit: state => {
    return state.local.isShowStatusLinesDeliveryNoteEmit
  },
  isShowQuantityLinesDeliveryNoteEmit: state => {
    return state.local.isShowQuantityLinesDeliveryNoteEmit
  },
  isShowMeasureLinesDeliveryNoteEmit: state => {
    return state.local.isShowMeasureLinesDeliveryNoteEmit
  },
  isShowQuantityTradeUnitLinesDeliveryNoteEmit: state => {
    return state.local.isShowQuantityTradeUnitLinesDeliveryNoteEmit
  },
  isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit: state => {
    return state.local.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit
  },
  isShowSerialNumberLinesDeliveryNoteEmit: state => {
    return state.local.isShowSerialNumberLinesDeliveryNoteEmit
  },
  isShowBatchLinesDeliveryNoteEmit: state => {
    return state.local.isShowBatchLinesDeliveryNoteEmit
  },
  isShowExpirationDateLinesDeliveryNoteEmit: state => {
    return state.local.isShowExpirationDateLinesDeliveryNoteEmit
  },
  isShowGtin14LinesDeliveryNoteEmit: state => {
    return state.local.isShowGtin14LinesDeliveryNoteEmit
  },

  // Columnas lineas pedido recibidas
  isShowItemCodeLinesDeliveryNoteReceived: state => {
    return state.local.isShowItemCodeLinesDeliveryNoteReceived
  },
  isShowItemCodeSellerLinesDeliveryNoteReceived: state => {
    return state.local.isShowItemCodeSellerLinesDeliveryNoteReceived
  },
  isShowItemCodeBuyerLinesDeliveryNoteReceived: state => {
    return state.local.isShowItemCodeBuyerLinesDeliveryNoteReceived
  },
  isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived: state => {
    return state.local.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived
  },
  isShowDescriptionLinesDeliveryNoteReceived: state => {
    return state.local.isShowDescriptionLinesDeliveryNoteReceived
  },
  isShowOrderLinesDeliveryNoteReceived: state => {
    return state.local.isShowOrderLinesDeliveryNoteReceived
  },  
  isShowStatusLinesDeliveryNoteReceived: state => {
    return state.local.isShowStatusLinesDeliveryNoteReceived
  },
  isShowQuantityLinesDeliveryNoteReceived: state => {
    return state.local.isShowQuantityLinesDeliveryNoteReceived
  },
  isShowMeasureLinesDeliveryNoteReceived: state => {
    return state.local.isShowMeasureLinesDeliveryNoteReceived
  },
  isShowQuantityTradeUnitLinesDeliveryNoteReceived: state => {
    return state.local.isShowQuantityTradeUnitLinesDeliveryNoteReceived
  },
  isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived: state => {
    return state.local.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived
  },
  isShowSerialNumberLinesDeliveryNoteReceived: state => {
    return state.local.isShowSerialNumberLinesDeliveryNoteReceived
  },
  isShowBatchLinesDeliveryNoteReceived: state => {
    return state.local.isShowBatchLinesDeliveryNoteReceived
  },
  isShowExpirationDateLinesDeliveryNoteReceived: state => {
    return state.local.isShowExpirationDateLinesDeliveryNoteReceived
  },
  isShowGtin14LinesDeliveryNoteReceived: state => {
    return state.local.isShowGtin14LinesDeliveryNoteReceived
  }  
}

// actions
const actions = {
  // Crear key Usuario
  // Crear key Usuario
  setUserNameDelivery ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalDelivery()
    }
  },
  async isNewVersionAlbaranesLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.albaranes)
    return isnew
  },

  /* albaranes */
  /**
  * Servicio para traer las albaranes emitidos y recibidos .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getDeliveryNotes ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      commit('DELIVERY_NOTES_EMIT_STATE', {
        tableData: response.data.content,
        totalDeliveryNotesEmit: response.data.totalElements
      })

      commit('DELIVERY_NOTES_RECEIVED_STATE', {
        tableData: response.data.content,
        totalDeliveryNotesReceived: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de una albaran
  async getDeliveryNoteDetail ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + params.deliveryId,
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Servicio de modificacion de albaran
  async modifyDeliveryNote ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/deliveryNote/' + data.deliveryId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.dataQuery.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los documentos relacionados de un albarán emitido o recibido
   */
  async getRelatedDocumentsDeliveryNote ({ commit, rootState }, data) {
    try {
      console.log('GET DELIVERY RELATED DOCUMENTS --- ', data.query)
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/deliveryNote/' + data.query.deliveryId + '/relatedDocuments',
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },


  /**
   * Servicio para eliminar un DeliveryNote
   * @param {*} data
   */
   async deleteDeliveryNote ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/deliveryNote/' + data.deliveryNoteId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },


/**
 * Servicio para descargar pdf de un albaran
 * @param {*} deliveryId
 */
  async downloadDeliveryNotePdf ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + params.deliveryId + '/pdf',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'albaran.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
/**
 * Servicio para descargar pdf del borrador de un albaran
 * @param {*} deliveryId
 */
  async downloadDeliveryNoteDraftPdf ({ commit, state }, deliveryId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + deliveryId + '/draftpdf',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'albaran.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async downloadDeliveryOriginal ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + params.deliveryId + '/original',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'albaran-original'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async downloadDeliveryMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + params.deliveryId + '/metadata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'albaran-metadata'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async downloadDeliveryDraftMetadata ({
    commit,
    rootState
  }, deliveryId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + deliveryId + '/draftmetadata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'albaran-metadata'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para descargar las etiquetas de un albaran
   * @param {*} deliveryId
   */
  async downloadDeliveryNoteLabels ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/' + params.deliveryId + '/labels',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'albaran-label.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener los tipos de estados de las albaranes emitidos y recibidos
   */
  async getOptionsFilterStatusDeliveryNote ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/deliverynotestatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterStatusDelivery = response.data
      commit('OPTIONS_FILTER_STATUS_DELIVERY_NOTES', optionsFilterStatusDelivery)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterStatusDelivery
    } catch (error) {
      console.log('status deliveryNote : ', error)
      throw error.response
    }
  },

  /**
     * Servicio para Exportar Todas las Albaranes  a CSV
     */
  async downloadDeliveryCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/deliveryNote/csv',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'deliveryNotes.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla Albaranes Emitidas
  deliveryNotesEmitState: ({ commit }, payload) => {
    commit('DELIVERY_NOTES_EMIT_STATE', payload)
  },
  queryDeliveryNotesEmitState: ({ commit }, payload) => {
    commit('QUERY_DELIVERY_NOTES_EMIT_STATE', payload)
  },
  listSelectedFiltersDeliveryNotesEmitState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_DELIVERY_NOTES_EMIT_STATE', payload)
  },

  // Datos Tabla Albaranes Recibidos
  deliveryNotesReceivedState: ({ commit }, payload) => {
    commit('DELIVERY_NOTES_RECEIVED_STATE', payload)
  },
  queryDeliveryNotesReceivedState: ({ commit }, payload) => {
    commit('QUERY_DELIVERY_NOTES_RECEIVED_STATE', payload)
  },
  listSelectedFiltersDeliveryNotesReceivedState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_DELIVERY_NOTES_RECEIVED_STATE', payload)
  },

  // Datos Select Filtros Albaranes Emitidas
  optionsFilterBuyerDeliveryNoteEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_DELIVERY_NOTES_EMIT', payload)
  },
  optionsFilterSellerDeliveryNoteEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_DELIVERY_NOTES_EMIT', payload)
  },
  optionsFilterDateCreationDeliveryNoteEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_DELIVERY_NOTES_EMIT', payload)
  },
  optionsFilterDateIssueDeliveryNoteEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_DELIVERY_NOTES_EMIT', payload)
  },
  optionsFilterDeliveryDateDeliveryNoteEmitState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATE_DELIVERY_NOTES_EMIT', payload)
  },  
  optionsFilterDeliveryNumberDeliveryNoteEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_NUMBER_DELIVERY_NOTES_EMIT', payload)
  },
  // Datos Select Filtros Albaranes Recibidos
  optionsFilterBuyerDeliveryNoteReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_DELIVERY_NOTES_RECEIVED', payload)
  },
  optionsFilterSellerDeliveryNoteReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_DELIVERY_NOTES_RECEIVED', payload)
  },
  optionsFilterDateCreationDeliveryNoteReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_DELIVERY_NOTES_RECEIVED', payload)
  },
  optionsFilterDateIssueDeliveryNoteReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_DELIVERY_NOTES_RECEIVED', payload)
  },
  optionsFilterDeliveryDateDeliveryNoteReceivedState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATE_DELIVERY_NOTES_RECEIVED', payload)
  },
  optionsFilterDeliveryNumberDeliveryNoteReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_NUMBER_DELIVERY_NOTES_RECEIVED', payload)
  },

  // Combo estados
  optionsFilterStatusDeliveryState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STATUS_DELIVERY_NOTES', payload)
  },

  // Columnas Tabla Albaranes Emitidas
  isShowBuyerDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_DELIVERY_NOTE_EMIT', payload)
  },
  isShowSellerDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_DELIVERY_NOTE_EMIT', payload)
  },
  isShowNumDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_DELIVERY_NOTE_EMIT', payload)
  },
  isShowDateCreationDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_DELIVERY_NOTE_EMIT', payload)
  },
  isShowDateIssueDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_DELIVERY_NOTE_EMIT', payload)
  },
  isShowDeliveryDateDeliveryNoteEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DELIVERY_DATE_DELIVERY_NOTE_EMIT', payload)
  },
  isShowStatusDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_DELIVERY_NOTE_EMIT', payload)
  },
  isShowServiceDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_DELIVERY_NOTE_EMIT', payload)
  },
  isShowCentroVendedorDeliveryNoteEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_DELIVERY_NOTE_EMIT', payload)
  },
  isShowCentroCompradorDeliveryNoteEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_DELIVERY_NOTE_EMIT', payload)
  },
  isShowCentroEntregaDeliveryNoteEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_DELIVERY_NOTE_EMIT', payload)
  },  
  isShowEnvioDeliveryNoteEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ENVIO_DELIVERY_NOTE_EMIT', payload)
  },
  // Columnas Tabla Albaranes Recibidos
  isShowBuyerDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowSellerDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowNumDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowDateCreationDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowDateIssueDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowDeliveryDateDeliveryNoteReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DELIVERY_DATE_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowStatusDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowServiceDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowCentroVendedorDeliveryNoteReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowCentroCompradorDeliveryNoteReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_DELIVERY_NOTE_RECEIVED', payload)
  },
  isShowCentroEntregaDeliveryNoteReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_DELIVERY_NOTE_RECEIVED', payload)
  },  
  isShowRecepcionDeliveryNoteReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_RECEPCION_DELIVERY_NOTE_RECEIVED', payload)
  },  
  // Columnas lineas emitidas
  isShowItemCodeLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODE_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowItemCodeSellerLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODESELLER_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowItemCodeBuyerLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODEBUYER_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowCodeCentreDeliveryPointLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CODE_CENTRE_DELIVERYPOINT_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowDescriptionLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowOrderLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ORDER_LINES_DELIVERYNOTE_EMIT', payload)
  },  
  isShowStatusLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowQuantityLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowMeasureLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURE_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowQuantityTradeUnitLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURETRADEUNIT_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowSerialNumberLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERIALNUMBER_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowBatchLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_BATCH_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowExpirationDateLinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_EXPIRATIONDATE_LINES_DELIVERYNOTE_EMIT', payload)
  },
  isShowGtin14LinesDeliveryNoteEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_GTIN14_LINES_DELIVERYNOTE_EMIT', payload)
  },

  // Columnas lineas recibidas
  isShowItemCodeLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODE_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowItemCodeSellerLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODESELLER_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowItemCodeBuyerLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODEBUYER_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowCodeCentreDeliveryPointLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_CODE_CENTRE_DELIVERYPOINT_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowDescriptionLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowOrderLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ORDER_LINES_DELIVERYNOTE_RECEIVED', payload)
  },  
  isShowStatusLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowQuantityLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowMeasureLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURE_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowQuantityTradeUnitLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURETRADEUNIT_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowSerialNumberLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERIALNUMBER_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowBatchLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_BATCH_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowExpirationDateLinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_EXPIRATIONDATE_LINES_DELIVERYNOTE_RECEIVED', payload)
  },
  isShowGtin14LinesDeliveryNoteReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_GTIN14_LINES_DELIVERYNOTE_RECEIVED', payload)
  }
}

// mutations
const mutations = {
  resetSessionAlbaranes (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  deliveryNoteDatesSuperAdmin (state) {
    state.session.queryDeliveryNotesEmit.creationDateTimeFrom = fn.initDateFrom(1)
    state.session.queryDeliveryNotesReceived.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Albaranes emitidos
  'DELIVERY_NOTES_EMIT_STATE' (state, payload) {
    state.session.deliveryNotesEmit = payload
  },
  'QUERY_DELIVERY_NOTES_EMIT_STATE' (state, payload) {
    state.session.queryDeliveryNotesEmit = payload
  },
  'LIST_SELECTED_FILTERS_DELIVERY_NOTES_EMIT_STATE' (state, payload) {
    state.session.listSelectedFiltersDeliveryNotesEmit = payload
  },

  // Albaranes Recibidos
  'DELIVERY_NOTES_RECEIVED_STATE' (state, payload) {
    state.session.deliveryNotesReceived = payload
  },
  'QUERY_DELIVERY_NOTES_RECEIVED_STATE' (state, payload) {
    state.session.queryDeliveryNotesReceived = payload
  },
  'LIST_SELECTED_FILTERS_DELIVERY_NOTES_RECEIVED_STATE' (state, payload) {
    state.session.listSelectedFiltersDeliveryNotesReceived = payload
  },

  // Datos Select Filtros Albaranes  Emitidas
  'OPTIONS_FILTER_BUYER_DELIVERY_NOTES_EMIT' (state, payload) {
    state.session.optionsFilterBuyerDeliveryNoteEmit = payload
  },
  'OPTIONS_FILTER_SELLER_DELIVERY_NOTES_EMIT' (state, payload) {
    state.session.optionsFilterSellerDeliveryNoteEmit = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_DELIVERY_NOTES_EMIT' (state, payload) {
    state.session.optionsFilterDateCreationDeliveryNoteEmit = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_DELIVERY_NOTES_EMIT' (state, payload) {
    state.session.optionsFilterDateIssueDeliveryNoteEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATE_DELIVERY_NOTES_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryDateDeliveryNoteEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_NUMBER_DELIVERY_NOTES_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryNumberDeliveryNoteEmit = payload
  },
  // Datos Select Filtros Albaranes Recibidos
  'OPTIONS_FILTER_BUYER_DELIVERY_NOTES_RECEIVED' (state, payload) {
    state.session.optionsFilterBuyerDeliveryNoteReceived = payload
  },
  'OPTIONS_FILTER_SELLER_DELIVERY_NOTES_RECEIVED' (state, payload) {
    state.session.optionsFilterSellerDeliveryNoteReceived = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_DELIVERY_NOTES_RECEIVED' (state, payload) {
    state.session.optionsFilterDateCreationDeliveryNoteReceived = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_DELIVERY_NOTES_RECEIVED' (state, payload) {
    state.session.optionsFilterDateIssueDeliveryNoteReceived = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATE_DELIVERY_NOTES_RECEIVED' (state, payload) {
    state.session.optionsFilterDeliveryDateDeliveryNoteReceived = payload
  },   
  'OPTIONS_FILTER_DELIVERY_NUMBER_DELIVERY_NOTES_RECEIVED' (state, payload) {
    state.session.optionsFilterDeliveryNumberDeliveryNoteReceived = payload
  },
  // Combo estados albaranes emitidos y recibidos
  'OPTIONS_FILTER_STATUS_DELIVERY_NOTES' (state, payload) {
    state.session.optionsFilterStatusDelivery = payload
  },

  // Columnas Tabla Albaranes Emitidas
  'IS_SHOW_BUYER_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowBuyerDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowBuyerDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowSellerDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowSellerDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowNumDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowNumDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowDateCreationDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDateCreationDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowDateIssueDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDateIssueDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_DATE_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowDeliveryDateDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDeliveryDateDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowStatusDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowStatusDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowServiceDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowServiceDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowCentroVendedorDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCentroVendedorDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowCentroCompradorDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCentroCompradorDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowCentroEntregaDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCentroEntregaDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },  
  'IS_SHOW_ENVIO_DELIVERY_NOTE_EMIT' (state, payload) {
    state.local.isShowEnvioDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowEnvioDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas Tabla Albaranes Recibidos
  'IS_SHOW_BUYER_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowBuyerDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowBuyerDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowSellerDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowSellerDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowNumDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowNumDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowDateCreationDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDateCreationDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowDateIssueDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDateIssueDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_DATE_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowDeliveryDateDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDeliveryDateDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowStatusDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowStatusDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowServiceDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowServiceDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowCentroVendedorDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCentroVendedorDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowCentroCompradorDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCentroCompradorDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowCentroEntregaDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCentroEntregaDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },  
  'IS_SHOW_RECEPCION_DELIVERY_NOTE_RECEIVED' (state, payload) {
    state.local.isShowRecepcionDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowRecepcionDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas lineas emitidas
  'IS_SHOW_ITEMCODE_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowItemCodeLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowItemCodeLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODESELLER_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowItemCodeSellerLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowItemCodeSellerLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODEBUYER_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowItemCodeBuyerLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowItemCodeBuyerLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODE_CENTRE_DELIVERYPOINT_LINES_DELIVERYNOTE_EMIT'  (state, payload) {
    state.local.isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowDescriptionLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDescriptionLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowOrderLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowOrderLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },  
  'IS_SHOW_STATUS_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowStatusLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowStatusLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowQuantityLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowQuantityLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURE_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowMeasureLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowMeasureLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURETRADEUNIT_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowQuantityTradeUnitLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowQuantityTradeUnitLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERIALNUMBER_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowSerialNumberLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowSerialNumberLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BATCH_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowBatchLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowBatchLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EXPIRATIONDATE_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowExpirationDateLinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowExpirationDateLinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GTIN14_LINES_DELIVERYNOTE_EMIT' (state, payload) {
    state.local.isShowGtin14LinesDeliveryNoteEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowGtin14LinesDeliveryNoteEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas lineas recibidas
  'IS_SHOW_ITEMCODE_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowItemCodeLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowItemCodeLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODESELLER_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowItemCodeSellerLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowItemCodeSellerLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODEBUYER_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowItemCodeBuyerLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowItemCodeBuyerLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODE_CENTRE_DELIVERYPOINT_LINES_DELIVERYNOTE_RECEIVED'  (state, payload) {
    state.local.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowDescriptionLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowDescriptionLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowOrderLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowOrderLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },  
  'IS_SHOW_STATUS_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowStatusLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowStatusLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowQuantityLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowQuantityLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURE_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowMeasureLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowMeasureLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURETRADEUNIT_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowQuantityTradeUnitLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowQuantityTradeUnitLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERIALNUMBER_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowSerialNumberLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowSerialNumberLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BATCH_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowBatchLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowBatchLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EXPIRATIONDATE_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowExpirationDateLinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowExpirationDateLinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GTIN14_LINES_DELIVERYNOTE_RECEIVED' (state, payload) {
    state.local.isShowGtin14LinesDeliveryNoteReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.albaranes.isShowGtin14LinesDeliveryNoteReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }  
}

export default {
  state,
  getters,
  actions,
  mutations
}
